import React, { useEffect, useRef, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Formik, Form } from 'formik'
import withAddress from '../../../hocs/address'
import BrForm from './forms/brazil-form'
import MxForm from './forms/mx-form'
import NormalForm from './forms/normal-form'
import { TOOGLE_UI_ALERT, TOOGLE_UI_CONFIRM } from '../../../../store/actions/ui'
import { useDispatch } from 'react-redux'
import { fetchStatesByCountry } from '../../../utils/global-fetchs'
import { FormattedMessage } from 'react-intl'
import { getCountryAppMessage } from '../../../../api'

export default withAddress(props => {
    useStyles(classes)
    const dispatch = useDispatch()
    const { validate, handleAddress, structedAddress, address, countries } = props
    // const privacyMsg = useRef()
    const [privacyMsg, setPrivacyMsg] = useState(null)

    useEffect(async () => {
        if(!privacyMsg){
            const res = await getCountryAppMessage("M1829")
            if(res?.code == 200){
                // privacyMsg.current = res?.result || {}
                setPrivacyMsg(res?.result || {})
            }
        }
    }, [])


    const submitHandle = async values => {
        const response = await handleAddress({...values, checkIPCountry: !!!address?.id})
        if(response?.code === 401){
            return new Promise(async (resolve, reject) => {
                const states = await fetchStatesByCountry(values?.country)
                const stateLabel = states?.find(s => s.value === values?.state)?.label || values?.state
                const countryLabel = countries?.find(s => s.value === values?.country)?.label || values?.country

                dispatch({
                    type: TOOGLE_UI_CONFIRM,
                    payload: {
                        show: true,
                        options: {
                            onCancel: () => {
                                dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                                resolve(false)
                            },
                            onConfirm: async () => {
                                dispatch({ type: TOOGLE_UI_CONFIRM, payload: null })
                                const secondResponse = await handleAddress({...values, checkIPCountry: false})
                                resolve(secondResponse)
                            },
                            okText: <FormattedMessage id="confirm" defaultMessage="Confirm"/>,
                            cancelText: <FormattedMessage id="modify" defaultMessage="Modify"/>,
                            content: <div className={classes.CountryConfirm}>
                                <div className={classes.Title}>
                                    <FormattedMessage id="please_sure_address_correct" defaultMessage="Please make sure the address you fill is correct"/>:
                                </div>
                                <div className={classes.Content}>
                                    <div>{values?.streetAddress1}, {values?.unit}</div>
                                    <div>{values?.zipCode}, {values?.city}</div>
                                    <div>{stateLabel}, <span className={classes.Country}>{countryLabel}</span></div>
                                </div>
                            </div>
                        }
                    }
                })
            })
        }else if(response?.code === 400){
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, payload: null })
                        },
                        content: response?.result || 'Network Error'
                    }
                }
            })
        }
        return response
    }

    return <React.Fragment>
        <Formik
            initialValues={structedAddress}
            onSubmit={submitHandle}
            validate={validate}
            key={address?.id}
        >
            {({ values }) => {
                switch (values.country) {
                    case 'BR':
                        return <BrForm {...props} privacyPic={privacyMsg?.imageUrl} privacyInfo={privacyMsg?.message}/>
                    case 'MX':
                        return <MxForm {...props} privacyPic={privacyMsg?.imageUrl} privacyInfo={privacyMsg?.message}/>
                    default:
                        return <NormalForm {...props} privacyPic={privacyMsg?.imageUrl} privacyInfo={privacyMsg?.message}/>
                }
            }}
        </Formik>
    </React.Fragment>
    
})